import React, { PropsWithChildren, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";

interface Props {
  dismiss: () => void;
}

const ModalWrapper = ({ children, dismiss }: PropsWithChildren<Props>) => (
  <div className="modal is-active">
    <div className="modal-background" onClick={dismiss} />
    <div className="modal-content">{children}</div>
    <button className="modal-close is-large" aria-label="close" onClick={dismiss} />
  </div>
);

const ModalPopup: React.FC<PropsWithChildren<Props>> = (props): React.ReactPortal => {
  const { children, dismiss } = props;

  const body = useMemo(() => window.document.body, []);
  const root = useMemo(() => window.document.getElementById("portal"), []);
  const el = useMemo(() => window.document.createElement("div"), []);
  console.log(body, root, el);

  useEffect(() => {
    if (body) {
      body.className = `${body.className} modal-active`.trim();
    }

    if (root) {
      root.appendChild(el);
    }

    return () => {
      if (body) {
        body.className = body.className.replace("modal-active", "").trim();
      }

      if (root) {
        root.removeChild(el);
      }
    };
  }, []);

  return createPortal(<ModalWrapper dismiss={dismiss}>{children}</ModalWrapper>, el);
};

export default ModalPopup;
